import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators, AbstractControl} from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { TransportistaService } from 'src/app/services/transportista.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { MatDialog } from "@angular/material/dialog";
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import  moment from 'moment';
import { DocumentoService } from 'src/app/services/documento.service';
import { UploadDocumentosService } from 'src/app/services/upload-documentos.service';
import { LoginService } from 'src/app/services/login.service';
import { ValidacionesService } from 'src/app/services/validaciones.service';

@Component({
  selector: 'app-nuevo-transportista-contratista',
  templateUrl: './nuevo-transportista-contratista.component.html',
  styleUrls: ['./nuevo-transportista-contratista.component.scss']
})
export class NuevoTransportistaContratistaComponent implements OnInit {

  public files: NgxFileDropEntry[] = [];
  public documentos: NgxFileDropEntry[] = [];

  isLinear = false;
  datosTransportista: any={};
  datosContacto: any = {};
  datosDocumento: any={};
  public transportistas: any[] = [];
  public transportista: any;
  public IDtransportistas: any[] = [];
  public transportistaSeleccionado: any;
  public transportistaContactos: any
  public transportistaContacto: any;
  public contratistaContactos: any
  public contratistaContacto: any
  public contactoSeleccionado: any
  public arrayContactos: any
  public nuevoArrayContactos: any
  public transportistaId: any
  public otherDate: any
  public datepicker: any
  public datepicker1: any
  public date: any
  public documento: any;
  public headers: any
  public relativePath: any
  public e: any
  token: any
  url: any
  contratista: any;
  idContratista: any;
  loading: any
  nameDocumento:any
  userLog:any
  public policy: any
  

  public fileOver(){
    /* console.log(event); */
  }

  public fileLeave(){
    /* console.log(event); */
  }

  constructor(private formBuilder: FormBuilder, private apollo: Apollo,
    private transportistaService: TransportistaService, private contratistaService: ContratistaService,
    public dialog: MatDialog, private documentoService: DocumentoService, private uploadService: UploadDocumentosService,
     private loginService: LoginService,  private validacionService: ValidacionesService) {
    this.buildForm();
  
  }

  ngOnInit() {
    this.userLog = this.loginService.getUserData()
    this.idContratista = this.userLog.contratista.id
     this.getTransportistasByContratista();
      this.getAllTransportistas()

  }

  getAllTransportistas() {
    this.apollo.watchQuery<any>({
      query: this.transportistaService.getAllTransportistas(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
        this.transportistas = data.transportistas
        console.log(this.transportistas)
      })
  }

  private buildForm(){
    this.datosTransportista = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      cif: ['',[Validators.required, this.validCif()]],
      codigo: [''],
      nima: ['', [Validators.required]],
      /* nombreContacto: ['', [Validators.required]],
      mailContacto: ['', [Validators.required,Validators.email]], */
    });
    this.datosContacto = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      mail: ['', [Validators.required,Validators.email]],
      contratista: this.idContratista,
    });
    this.policy = this.formBuilder.group({
      policy: ['', [Validators.required]],
    });

    this.datosDocumento = this.formBuilder.group({
      nombre: [''],
      fechaValidez: ['',[Validators.required]],
      fechaCaducidad: [''],
      noCaduca:[''],
    });
  }

  validCif(){
    return (control: AbstractControl):{[key: string]: boolean} | null=>{
    
    
   let cif:any = control.value
  
      if(this.validacionService.checkCif(cif) == false){
      
        return {'validCif':true}
      }
    return null;
    }
  }

  getDate(fecha: any){
    this.date = moment(new Date(fecha)).format('Y-MM-DD')
    console.log(this.date)
  }

   getOtherDate(fecha: any){
    this.otherDate = moment(new Date(fecha)).format('Y-MM-DD')
    /* console.log(this.otherDate) */
  }
  
   save(event:Event){
    event.preventDefault();
    const value = this.datosTransportista.value;
    console.log(value);
  }

   getTransportistasByContratista() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getTransportistasByContratista(),
      variables: {
        "id": this.idContratista
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.transportistas = data.contratista.transportistas
        this.transportistas?.forEach(transportista => 
        this.IDtransportistas.push(transportista.id));
        console.log(this.IDtransportistas)
          }
      )
  }

  addTransportista(){
    this.apollo.mutate<any>({
      mutation: this.transportistaService.addTransportista(),
      variables: {
        "input": {
          "data": {
            "contratistas":this.idContratista,
            "nombre": this.datosTransportista.value.nombre,
            "cif": this.datosTransportista.value.cif,
            "codigo": this.datosTransportista.value.codigo,
            "nima": this.datosTransportista.value.nima,
            "nombreContacto": this.datosTransportista.value.nombreContacto,
            "mailContacto": this.datosTransportista.value.mailContacto,
            "contratistaContacto": {
              "nombre": this.datosContacto.value.nombre,
              "mail": this.datosContacto.value.mail,
              "contratista": this.idContratista,
            },
            "policy":this.policy.value.policy

          }
        }
      }
    }).subscribe(({data}) => {
      console.log('OK', data)
      this.IDtransportistas.push(data.createTransportista.transportista.id)
      this.updateContratistaById()
      this.transportistaId = data.createTransportista.transportista.id;
      setTimeout(() => {
        this.addDocumento();
        location.reload()
      }, 370);
      
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  addDocumento(){
   
   if (this.datosDocumento.value.noCaduca === '') {
     this.datosDocumento.value.noCaduca = null
   }
   this.getDate(this.datosDocumento.value.fechaValidez)
   if(this.datosDocumento.value.fechaCaducidad){
   this.getOtherDate(this.datosDocumento.value.fechaCaducidad)
   }
   
   this.apollo.mutate<any>({
     mutation: this.documentoService.addDocumento(),
     variables: {
       "input": {
         "data": {
           "nombre": this.nameDocumento,
           "fechaValidez": this.date,
           "fechaCaducidad": this.otherDate,
           "noCaduca": this.datosDocumento.value.noCaduca,
           "obligatorio": true,
           "tipo": "pendiente",
           "nombreArchivo":"autorizacion1",
           "transportista": this.transportistaId,
           "url": this.url,
           "validado": false,
           "comentariosNuevos": true,
           "subidoPor": this.userLog.id
         }
       }
     }
   }).subscribe(({data}) => {
     console.log('OK', data)
     
   }, (error) => {
     console.log('Error al lanzar la query', error);
   })
 }

 dropped(files: any){
  this.uploadService.dropped(files).subscribe((res:any)=>{
    this.nameDocumento = res[0].name
    this.url = res[0].url  
  })
  
 }

    updateContratistaById(){
    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": this.idContratista
          },
          "data": {
            "transportistas": this.IDtransportistas
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  getTransportistaById(){  
    
    if (this.transportistaSeleccionado != '0') {
    this.apollo.watchQuery<any>({
      query: this.transportistaService.getTransportistaById(),
      variables: {
        id: this.transportistaSeleccionado
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.transportista = data.transportista
        console.log(this.transportista)
        this.contratistaContactos = this.transportista.contratistaContacto;
        console.log(this.transportistaContactos)
        this.contactoSeleccionado = this.contratistaContactos.filter((contratistaContacto: any) => contratistaContacto.contratista === this.idContratista)
       this.displayTransportista()
      })
      }
      if(this.transportistaSeleccionado === '0') {
      this.datosTransportista.reset()
      this.datosContacto.reset()
    }
  }

  displayTransportista(){

    if(this.transportistaSeleccionado === '0') {
      this.datosTransportista.reset()
      this.datosContacto.reset()
    }
    if(this.datosTransportista){
      this.datosTransportista.reset()
    }
    this.datosTransportista.patchValue({
      cif: this.transportista.cif,
      nombre: this.transportista.nombre,
      codigo: this.transportista.codigo,
      nima: this.transportista.nima,
     
    })
    if(this.datosContacto){
      this.datosContacto.reset()
    }

    if(this.contactoSeleccionado.length === 1){
    this.datosContacto.patchValue({
      nombre: this.contactoSeleccionado[0].nombre,
      mail: this.contactoSeleccionado[0].mail,
      
    })
    }
  }

  updateTransportistaById(){
    
    this.arrayContactos = this.contratistaContactos.filter((contratistaContacto: any) => contratistaContacto.contratista != this.idContratista)
   
    if (this.datosContacto.value.contratista === null){
      this.datosContacto.value.contratista = this.idContratista
    }

   this.nuevoArrayContactos = this.arrayContactos.push(this.datosContacto.value)

    this.apollo.mutate({
      mutation: this.transportistaService.updateTransportista(),
      variables: {
        "input": {
          "where": {
            "id": this.transportistaSeleccionado
          },
          "data": {
            "contratistas":this.idContratista,
            "nombre": this.datosTransportista.value.nombre,
            "cif": this.datosTransportista.value.cif,
            "codigo": this.datosTransportista.value.codigo,
            "nima": this.datosTransportista.value.nima,
            "nombreContacto": this.datosTransportista.value.nombreContacto,
            "mailContacto": this.datosTransportista.value.mailContacto,
            "contratistaContacto": this.arrayContactos,
            "policy": this.policy.value.policy
            }
          }
        }    
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
        location.reload()
      }, (error) => {
        console.log(error)
      })
  }
  

}
